export default "__VITE_ASSET__d689732f__"